import { Dispatch } from "react";
import {Types} from "./PrestacionContext";
import { dispatch } from "d3";


export const openCreateModal = (dispatch: Dispatch<any>):void =>{
    dispatch({type: Types.CREATE_BENEFITS});
}

export const openUpdateModal = (_id: string, dispatch: Dispatch<any>):void =>{
    dispatch({
        type: Types.UPDATE_BENEFITS,
        payload: {_id},
    });
}

export const openDeleteModal = (_id: string, dispatch:Dispatch<any>):void =>{
    dispatch({
        type: Types.DELETE_BENEFITS,
        payload:{_id},
    })
}

export const createUserBenefitsModal = (dispatch: Dispatch<any>):void =>{
    dispatch({
       type:Types.CREATE_USER_BENEFITS,
    })
}

export const closeUserBenefitsModal = (dispatch: Dispatch<any>):void => {
    dispatch({
        type: Types.CLOSE_USER_BENEFITS_MODAL,
    })
}

export const clearAllModals = (dispatch: Dispatch<any>):void =>{
    dispatch({type: Types.CLEAR_BENEFITS,
        payload: { _id: '', createModalBenefits: false, updateModalBenefits: false, deleteModalBenefits: false}
    })
}

export const startglobalLoading = (dispatch: Dispatch<any>): void => {
    dispatch({ type: Types.START_LOADING});
}

export const stopGlobalLoading = (dispatch: Dispatch<any>): void => {
    dispatch({ type: Types.STOP_LOADING});
}

// export const closeBenefits = (openNewWorkSchedule=false, dispatch:Dispatch<any>):void =>{
//     dispatch({
//         type: Types.CLOSE_NEW_WORK_SCHEDULE,
//         payload:{
//             openNewWorkSchedule
//         }
//     })
// }

// export const closeListWorkSchedule = (openListSchedule=false, dispatch:Dispatch<any>):void =>{
//     dispatch({
//         type: Types.CLOSE_LIST_WORK_SCHEDULE,
//         payload:{
//             openListSchedule
//         }
//     })
// }

